import React from "react";
import MuiCheckbox from "@mui/material/Checkbox";

import useBreakpoints from "../hooks/useBreakpoints";
import { Tooltip } from "..";
import { CheckboxProps } from "./Checkbox.types";
import { useCheckboxStyles } from "./Checkbox.styles";
import Icon from "./Icon";
import CheckedIcon from "./CheckedIcon";
import IconMobile from "./IconMobile";
import CheckedIconMobile from "./CheckedIconMobile";

function Checkbox(
  props: CheckboxProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const {
    onChange,
    onChangeValue,
    onClickCapture: onClickCaptureProp,
    disabledTooltip,
    disabled,
    inputProps,
    tooltipAction,
    ...other
  } = props;

  const checkboxClasses = useCheckboxStyles(props);

  const { mdUp } = useBreakpoints();

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (onChange) {
      onChange(event, checked);
    }
    if (onChangeValue) {
      onChangeValue(checked);
    }
  };

  const onClickCapture = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    onClickCaptureProp?.(event);
  };

  const checkbox = (
    <MuiCheckbox
      {...other}
      ref={ref}
      icon={mdUp ? <Icon /> : <IconMobile />}
      checkedIcon={mdUp ? <CheckedIcon /> : <CheckedIconMobile />}
      classes={checkboxClasses}
      disableRipple
      onChange={handleChange}
      onClickCapture={onClickCapture}
      disabled={disabled}
      inputProps={{
        ...inputProps,
        disabled: false,
        "aria-disabled": disabled,
      }}
    />
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} action={tooltipAction}>
        {checkbox}
      </Tooltip>
    );
  }

  return checkbox;
}

export default React.forwardRef(Checkbox);
